<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2242_5177)">
<rect x="6" y="14" width="4" height="1" fill="currentColor"/>
<rect x="16" y="14" width="6" height="1" fill="currentColor"/>
<path d="M14 21C14 20.1035 14.7268 19.3767 15.6233 19.3767L22.3767 19.3767C23.2732 19.3767 24 20.1035 24 21L14 21Z" fill="currentColor"/>
<rect opacity="0.1" x="13" y="9" width="12" height="12" fill="currentColor"/>
<rect x="28" y="14" width="4" height="1" fill="currentColor"/>
</g>
<rect x="2.3" y="8.3" width="33.4" height="13.4" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
<defs>
<clipPath id="clip0_2242_5177">
<rect x="3" y="9" width="32" height="12" rx="0.5" fill="white"/>
</clipPath>
</defs>
</svg>
